import AOS from "aos";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import BrandsMarqueSection from "../../common/BrandsMarqueSection";
import Cursor from "../../common/Cursor";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import Loader from "../../common/Loader";
import MarqueSection from "../../common/MarqueSection";
import ProgressCircle from "../../common/ProgressCircle";
import TestimonialSlider from "../../common/TestimonialSlider";
import TextMarqueSection from "../../common/TextMarqueSection";
import SectionOne from "./SectionOne";
import SectionThree from "./SectionThree";
import SectionTwo from "./SectionTwo";
const About = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <>
      <Helmet>
        <title>About Us | Marichi Tech AI</title>
        <meta
          name="description"
          content="Learn more about our IT solutions, mission, and services."
        />
        <meta
          name="keywords"
          content="IT, technology, software development, web development"
        />
        <meta property="og:title" content="About Us |  Marichi Tech AI" />
        <meta
          property="og:description"
          content="We provide cutting-edge IT services to boost your business."
        />
        <meta
          property="og:image"
          content="https://example.com/your-image.jpg"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <Loader />
      <div className="site_contain">
        {/* <!-- ====================================== Cusrsor ===================================== --> */}
        <Cursor />
        {/* <!-- ====================================== Cursor End ===================================== --> */}
        {/* <!-- ====================================== Header Menu ===================================== --> */}
        <Header />
        {/* <!-- ====================================== Header Menu End===================================== --> */}
        {/* <!-- ====================================== About Section One Start ===================================== --> */}
        <SectionOne />
        {/* <!-- ====================================== About Section One End ===================================== --> */}
        {/* <!-- ====================================== About Section Two Start ===================================== --> */}
        <SectionTwo />
        {/* <!-- ====================================== About Section Two End ===================================== --> */}
        {/* <!-- ====================================== About Section Counter ===================================== --> */}
        {/* <CounterSection /> */}
        {/* <!-- ====================================== About Section Counter ===================================== --> */}
        {/* <!-- ====================================== About Section Three Start ===================================== --> */}
        <SectionThree />
        {/* <!-- ====================================== About Section Three End ===================================== --> */}
        {/* <!-- ====================================== User Branding Marquee Section ===================================== --> */}
        <MarqueSection />
        {/* <!-- ====================================== User Branding Marquee Section ===================================== --> */}
        {/* <!-- ====================================== About Section Four ===================================== --> */}
        {/* <SectionFour /> */}
        {/* <!-- ====================================== About Section Four End ===================================== --> */}
        {/* <!-- ====================================== Testimonial Slider ===================================== --> */}
        <TestimonialSlider />
        {/* <!-- ====================================== Testimonial Slider End ===================================== --> */}
        {/* <!-- ====================================== Brands Marquee Section Start ===================================== --> */}
        <BrandsMarqueSection />
        {/* <!-- ====================================== Brands Marquee Section End ===================================== --> */}
        {/* <!-- ====================================== text Marquee Section Start ===================================== --> */}
        <TextMarqueSection />
        {/* <!-- ====================================== text Marquee Section End ===================================== --> */}
        {/* <!-- ====================================== Footer ===================================== --> */}
        <Footer />
        {/* <!-- ====================================== Progress Scroll Bottom To Top ===================================== --> */}
        <ProgressCircle />
        {/* <!-- ====================================== Progress Scroll Bottom To Top End ===================================== --> */}
      </div>
    </>
  );
};
export default About;
